// ILLUSTRATIVE SAMPLE CONTENT — not genuine published client reviews.
// Replace with real, permissioned reviews before launch. Set isSample to false only for genuine reviews.
export const reviewsAreSample = true;

export const reviews = [
  {
    n: '01',
    quote: 'Thoughtful advice, clear understanding, and a genuine commitment to finding the right people.',
    context: 'They took the time to understand how our team actually works before recommending anyone. The result was a leadership hire who felt right from the first week.',
    name: 'Sample Client',
    role: 'Founder, growth-stage business',
    rating: 5,
    isSample: true,
  },
  {
    n: '02',
    quote: 'Calm, honest guidance through a difficult restructure. We always knew where we stood.',
    context: 'Every conversation was candid and considered. They helped us protect the people who mattered most while the organisation changed around them.',
    name: 'Sample Client',
    role: 'Operations Director',
    rating: 5,
    isSample: true,
  },
  {
    n: '03',
    quote: 'A partner who listens first. Every shortlist reflected what we had actually asked for.',
    context: 'No volume, no noise — just a small number of people who genuinely fitted the role, the team, and where we were heading next.',
    name: 'Sample Client',
    role: 'Head of People',
    rating: 5,
    isSample: true,
  },
];